import React from "react";
import { FaStreetView } from "react-icons/fa";
import { IoMdDocument } from "react-icons/io";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
const Headermenu = ({ userRole }) => {
  const item = [
    {
      url: "/employee/booking",
      text: "Booking",
      icon: <IoMdDocument />,
      accessRole: ["Employee"],
    },
    {
      url: "/employee/view",
      text: "View",
      icon: <FaStreetView />,
      accessRole: ["Employee"],
    },
  ];
  return (
    <div className="nav">
      {item
        .filter((data) => data.accessRole.includes(userRole)) // Filter items based on userRole
        .map((data) => {
          return (
            <div className="nav-item" key={data.id}>
              <NavLink
                to={data.url} // Use 'url' for the path to navigate to
                className={
                  ({ isActive }) => (isActive ? "nav-link active" : "nav-link") // Conditionally apply the 'active' class based on isActive
                }
              >
                {data.icon}
                <span className="ms-1">{data.text}</span>
              </NavLink>
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "user",
});

export default connect(mapStateToProps)(Headermenu);
